export default "__VITE_ASSET__d166ba7e__"